<template>
    <div class="locations-create-modal">
        <ModalContainer :title="$t('locations.add_location')" identifier="locations-create-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">
                <FormInputText v-model="$v.location.name.$model" identifier="name" :label="$t('locations.name')"
                               :disabled="is_saving" :has-error="$v.location.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.location.name.required">
                            {{$t('validation.x_is_required',{x: $t('locations.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "LocationsCreateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        data() {
            return {
                location: {
                    name: null,
                },
                is_saving: false,
            }
        },
        validations: {
            location: {
                name: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('locations-create-modal', status);
            },
            save() {
                this.$v.location.$touch();
                if (this.$v.location.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                const payload = Object.assign({}, this.$v.location.$model);

                this.$axios.post(`locations`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('locations.success_created'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('locations.error_create')),
                        type: 'error',
                    });
                });
            },
        },
    }
</script>
